import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: require("../public/locales/en/common.json"),
      },
      emji: {
        common: require("../public/locales/emji/common.json"),
      },
    },
  });

export default i18n;